import type {
    Door,
    DoorColor,
    DoorMaterial,
    DoorStyle
} from '@/types'

export const doorStyles: DoorStyle[] = ['Traditional', 'Carriage house', 'Modern', 'Full-view glass']

export const doorMaterials: DoorMaterial[] = ['Steel', 'Wood-look composite', 'Wood', 'Aluminum & glass']

export const doorColors: DoorColor[] = ['White', 'Sandstone', 'Charcoal', 'Walnut', 'Black']

export const doorSwatches: Record<DoorColor, string> = {
    White: '#f3f1ec',
    Sandstone: '#cdb999',
    Charcoal: '#3b3e42',
    Walnut: '#6e4a2e',
    Black: '#141414'
}

export const doors: Door[] = [
    {
        id: 'ridgeline-classic',
        name: "Ridgeline Classic",
        style: 'Traditional',
        material: 'Steel',
        colors: ['White', 'Sandstone', 'Charcoal'],
        rValue: 'R-9',
        priceFrom: 1150,
        priceTo: 1650,
        image: '/images/doors/ridgeline-classic-hd.jpg',
        colorImages: {
            Sandstone: '/images/doors/colors/ridgeline-classic-sandstone.jpg',
            Charcoal: '/images/doors/colors/ridgeline-classic-charcoal.jpg'
        }
    },
    {
        id: 'briar-short-panel',
        name: "Briar Short Panel",
        style: 'Traditional',
        material: 'Wood-look composite',
        colors: ['Charcoal', 'Walnut', 'White'],
        rValue: 'R-12',
        priceFrom: 1600,
        priceTo: 2300,
        image: '/images/doors/briar-short-panel-hd.jpg',
        colorImages: {
            Walnut: '/images/doors/colors/briar-short-panel-walnut.jpg',
            White: '/images/doors/colors/briar-short-panel-white.jpg'
        }
    },
    {
        id: 'hartwell-carriage',
        name: "Hartwell Carriage",
        style: 'Carriage house',
        material: 'Wood-look composite',
        colors: ['Walnut', 'White', 'Black'],
        rValue: 'R-12',
        priceFrom: 2400,
        priceTo: 3600,
        image: '/images/doors/hartwell-carriage-hd.jpg',
        colorImages: {
            White: '/images/doors/colors/hartwell-carriage-white.jpg',
            Black: '/images/doors/colors/hartwell-carriage-black.jpg'
        }
    },
    {
        id: 'ashgrove-carriage',
        name: "Ashgrove Carriage",
        style: 'Carriage house',
        material: 'Wood',
        colors: ['Walnut', 'Charcoal'],
        rValue: 'R-6',
        priceFrom: 3400,
        priceTo: 4800,
        image: '/images/doors/ashgrove-carriage-hd.jpg',
        colorImages: {
            Charcoal: '/images/doors/colors/ashgrove-carriage-charcoal.jpg'
        }
    },
    {
        id: 'norrland-flush',
        name: "Norrland Flush",
        style: 'Modern',
        material: 'Steel',
        colors: ['Charcoal', 'Black', 'White', 'Sandstone'],
        rValue: 'R-16',
        priceFrom: 1450,
        priceTo: 2200,
        image: '/images/doors/norrland-flush-hd.jpg',
        colorImages: {
            Black: '/images/doors/colors/norrland-flush-black.jpg',
            White: '/images/doors/colors/norrland-flush-white.jpg',
            Sandstone: '/images/doors/colors/norrland-flush-sandstone.jpg'
        }
    },
    {
        id: 'cedar-line-plank',
        name: "Cedar Line Plank",
        style: 'Modern',
        material: 'Wood',
        colors: ['Walnut', 'Black'],
        rValue: 'R-9',
        priceFrom: 3200,
        priceTo: 4600,
        image: '/images/doors/cedar-line-plank-hd.jpg',
        colorImages: {
            Black: '/images/doors/colors/cedar-line-plank-black.jpg'
        }
    },
    {
        id: 'clearview-pane',
        name: "Clearview Pane",
        style: 'Full-view glass',
        material: 'Aluminum & glass',
        colors: ['Black', 'Charcoal', 'White'],
        rValue: 'R-4',
        priceFrom: 3200,
        priceTo: 4800,
        image: '/images/doors/clearview-pane-hd.jpg',
        colorImages: {
            Charcoal: '/images/doors/colors/clearview-pane-charcoal.jpg',
            White: '/images/doors/colors/clearview-pane-white.jpg'
        }
    },
    {
        id: 'clearview-frost',
        name: "Clearview Frost",
        style: 'Full-view glass',
        material: 'Aluminum & glass',
        colors: ['Charcoal', 'Black'],
        rValue: 'R-4',
        priceFrom: 3400,
        priceTo: 4800,
        image: '/images/doors/clearview-frost-hd.jpg',
        colorImages: {
            Black: '/images/doors/colors/clearview-frost-black.jpg'
        }
    }
]

export const doorSteps: { title: string, body: string }[] = [
    { title: "Choose a look", body: "Pick from the gallery, or book a visit and we'll bring samples to your driveway." },
    { title: "Free measure at home", body: "About 20 minutes with a tape and a notepad, at no charge." },
    { title: "A written quote", body: "Three options to compare, each priced fully installed." },
    { title: "Fitting day", body: "The old door comes down and the new one goes up, in around 5 hours." }
]
